import React from "react";

import HomeServices from './components/HomeServices';
import HomeDeliveries from './components/HomeDeliveries';
import HomeAbout from "./components/HomeAbout";
import HomeContact from "./components/HomeContact";

const Home = ({ home }) => {

  return (
    <main className="Home">
      <HomeServices home={home} />
      <HomeDeliveries home={home} />
      <HomeAbout />
      <HomeContact home={home} />
    </main>
  );
  
}

export default Home;